/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectionStrategy, Component, DestroyRef, Input, OnInit, inject} from '@angular/core';
import {UIRouterModule} from '@uirouter/angular';

import template from './cdn-upload-list-page.component.html';
import {
  SignalAdminListColumn,
  SignalAdminResourceListStateFactory
} from '../../common/controller/signal-admin-resource-list-state';
import {CdnUploadApiService, CdnUploadModel} from './cdn-upload-api.service';
import {APP_SHARED} from '../../common/app-shared';
import {SignalAdminResourceListComponent} from '../../common/controller/signal-admin-resource-list.component';
import {CREATIVE_ASSETS} from '../../creative/creative-assets';

@Component({
  standalone: true,
  imports: [...APP_SHARED, UIRouterModule, SignalAdminResourceListComponent, ...CREATIVE_ASSETS],
  selector: 'adn-cdn-upload-list-page',
  template,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CdnUploadListPageComponent implements OnInit {
  readonly itemStateName = 'app.adm.cdn-uploads.cdn-upload';
  readonly columns: SignalAdminListColumn[] = [
    {param: 'fileName', label: 'name', sortable: false},
    {param: 'cdnId', label: 'cdnUrl', sortable: false},
    {param: 'mimeType'},
    {param: 'fileSizeBytes'},
    {param: 'width', label: 'dimensions', numeric: true},
    {param: 'createTime'},
    {param: 'updateTime'}
  ];
  readonly list = inject(SignalAdminResourceListStateFactory).create<CdnUploadModel>(
    inject(CdnUploadApiService),
    {listId: 'fullCdnUploadList', defaultOrderBy: 'width'},
    inject(DestroyRef)
  );

  @Input()
  set readOnly(value: boolean) {
    this.list.readOnly.set(value);
  }

  ngOnInit(): void {
    this.list.load();
  }

  httpsPrefix(value: string): string {
    return value && value.indexOf('//') === 0 ? 'https:' + value : value;
  }
}
